/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiRequestConfig } from 'app/interfaces/api-request/api.interface';
import endpoints from 'constants/endpoints';
import { call, put, takeLatest } from 'redux-saga/effects';
import { IPagination } from 'app/redux/reducers/PortofolioReducer';
import {
	getTransactionHistoryListAction,
	setTransactionHistoryListAction,
	TransactionHistoryParamsRequest,
	ITransactionHistoryListResponse,
} from '../actions/TransactionHistoryAction';
import apiRequest from '../api/api.request';
import { TransactionHistoryListItem } from '../reducers/TransactionHistoryReducer';

export const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1,
};

export const DummyTransactionHistoryListItem: any = [];

function* fetchTransactionHistoryList({
	payload,
}: {
	payload: TransactionHistoryParamsRequest;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.TRANSACTION_HISTORY_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			"X-Authenticated-Userid": `${JSON.parse(auth).userId}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const result = {
			transactionHistoryList: data,
			pagination,
		};
		yield put(setTransactionHistoryListAction(result));
		return payload;
	} catch (err) {
		const result = {
			transactionHistoryList: DummyTransactionHistoryListItem,
			pagination: paginationInit,
		};
		yield put(setTransactionHistoryListAction(result));
		return err;
	}
}

function setTransactionHistoryListSaga({
	payload,
}: {
	payload: ITransactionHistoryListResponse;
}): TransactionHistoryListItem[] | unknown {
	try {
		return payload;
	} catch (err) {
		// TODO: error handler
		return err;
	}
}

export default function* transactionHistorySaga(): Generator {
	yield takeLatest(
		getTransactionHistoryListAction,
		fetchTransactionHistoryList
	);
	yield takeLatest(
		setTransactionHistoryListAction,
		setTransactionHistoryListSaga
	);
}
